/**
 * Direct Contacts — departments directory.
 * On mobile each department is an independent accordion; on desktop everything
 * is shown at once (the toggle does nothing — CSS keeps the body open).
 *
 * Wired immediately (not via the lazy initSection) so the very first tap on a
 * department header opens it.
 */
const MOBILE = '(max-width: 1024.98px)';

export const directContacts = () => {
    return new Promise((resolve) => {
        document.querySelectorAll('.direct-contacts').forEach((section) => init(section));
        resolve();
    });
};

const init = (section) => {
    const items = [...section.querySelectorAll('.direct-contacts__dept')];

    items.forEach((item) => {
        const toggle = item.querySelector('.direct-contacts__dept-toggle');
        if (!toggle) return;

        toggle.addEventListener('click', () => {
            // Desktop: no accordion behaviour, the body is always visible.
            if (!window.matchMedia(MOBILE).matches) return;

            const isOpen = item.classList.toggle('is-open');
            toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        });
    });
};
